export default __webpack_public_path__ + "static/userDummy1-a7a8bbf842d8bdd295479e3938968a28.jpg";